import { render, staticRenderFns } from "./ArrowUp.vue?vue&type=template&id=7fdc0a4b&"
import script from "./ArrowUp.vue?vue&type=script&lang=js&"
export * from "./ArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports